module.exports = __webpack_public_path__ + "media/images/appIcon-2a45a1aecfab55638d15bd78b33f5199.png";